var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SimpleTable',{ref:"table",attrs:{"columns":_vm.columnDefinition,"data":_vm.rows,"highlight":_vm.highlightSelected,"disable-internal-sort":true,"fixed-header":""},on:{"sorted":_vm.onSorted,"scroll":_vm.onScroll},scopedSlots:_vm._u([{key:"area",fn:function(ref){
var value = ref.value;
return [_c('span',[_vm._v(_vm._s(_vm._f("formatAsHectare")(value)))])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }